"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@material-ui/core");
const react_1 = __importStar(require("react"));
require("./billing-info.scss");
const react_redux_1 = require("react-redux");
const profileSlice_1 = require("../../../../redux/slices/profileSlice");
class BillingComponent extends react_1.Component {
    constructor() {
        super(...arguments);
        this.formChange = (e, field, validate = false) => {
            const value = e.target.value;
            this.props.userFormChange({ value, field, validate });
        };
    }
    render() {
        var _a, _b;
        const { edit = false, user, profile: { userForm: { data: form } }, data, error } = this.props;
        return (react_1.default.createElement("div", { className: 'billing-container' },
            react_1.default.createElement("div", { className: "section-info-head" },
                react_1.default.createElement("div", { className: "section-info-title" }, "Billing Information")),
            react_1.default.createElement("div", { className: 'content' }, !edit ? data.price ?
                react_1.default.createElement("span", null,
                    "Hourly Rate:",
                    react_1.default.createElement("span", { className: 'hourly-rate ml-10' },
                        "$",
                        data.price.toFixed(2))) :
                "Please edit your profile and write hourly rate to complete your profile." :
                react_1.default.createElement("div", { className: "text-field-custom-mb" },
                    react_1.default.createElement(core_1.TextField, { fullWidth: true, "data-qa": 'hourly_rate', placeholder: `Hourly Rate ${((_a = user === null || user === void 0 ? void 0 : user.linked_lf) === null || _a === void 0 ? void 0 : _a.activated) === 0 ? '(optional)' : ''}`, value: ((_b = form === null || form === void 0 ? void 0 : form.hourly_rate) === null || _b === void 0 ? void 0 : _b.value) || '', error: error, onChange: (e) => this.formChange(e, 'hourly_rate'), onBlur: (e) => this.formChange(e, 'hourly_rate', true), id: "hourly_rate" }))),
            react_1.default.createElement("div", { className: "block-separator" })));
    }
}
;
const mapStateToProps = (state) => {
    const { user, profile } = state;
    return {
        user,
        profile
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        userFormChange: (data) => dispatch(profileSlice_1.userFormChange(data)),
        setFormUpdate: () => dispatch(profileSlice_1.setFormUpdate()),
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(BillingComponent);
